/* SunKissed sticky ATC fix v3
   Forces an immediate scroll check on page load so Ella correctly
   hides the sticky bar while the main Add to Cart is on screen.
   Ella's own onScroll logic does the rest. */
(function () {
  'use strict';

  function runOnReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  runOnReady(function () {
    var attempts = 0;

    function triggerCheck() {
      var el = document.querySelector('sticky-add-to-cart');
      if (!el) {
        if (++attempts < 20) setTimeout(triggerCheck, 300);
        return;
      }

      // Fire a synthetic scroll so Ella's onScroll handler runs immediately
      // and sets the correct show/hide state before the user touches anything.
      window.dispatchEvent(new Event('scroll'));

      // Belt-and-braces: run again after 800ms in case JS bundles load late.
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 800);
    }

    triggerCheck();
  });
})();
